import { attr } from '@ember-data/model';
import ShModel from './sh-model';

/**
 * These are mapped to the specific transforms in Cloudinary. You must add there for these to work.
 */
export default ShModel.extend({
  profile128: attr('string'),
  profile480: attr('string'),
  thumbnail800 : attr('string'),
  thumbnailRound800 : attr('string'),
  embedThumbnail: attr('string'),
});
